import { create } from 'zustand';

// true quando há chave Clerk no build — então o login real (Microsoft SSO) é
// gerido pelo Clerk. Sem chave (dev/local), usamos uma sessão local simples
// que ainda assim exige "entrar" e permite "sair" — o backend trata o usuário
// como admin aprovado (dev-user), retornado por GET /api/me.
export const clerkEnabled = Boolean(import.meta.env.VITE_CLERK_PUBLISHABLE_KEY);

// Acesso mínimo e tipado ao singleton global do Clerk (window.Clerk), populado
// pelo ClerkProvider. Usado fora de componentes (api-client) e em chrome
// compartilhado (Sidebar) onde não dá para chamar hooks do Clerk.
export interface ClerkGlobal {
  openSignIn: (props?: Record<string, unknown>) => void;
  signOut: () => Promise<void>;
  session?: { getToken: () => Promise<string | null> } | null;
  client?: {
    signIn?: {
      authenticateWithRedirect: (params: {
        strategy: string;
        redirectUrl: string;
        redirectUrlComplete: string;
      }) => Promise<unknown>;
    };
  };
}

export function getClerk(): ClerkGlobal | undefined {
  if (typeof window === 'undefined') return undefined;
  return (window as unknown as { Clerk?: ClerkGlobal }).Clerk;
}

const KEY = 'master-apps:session';

function load(): boolean {
  if (typeof localStorage === 'undefined') return false;
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

interface SessionState {
  signedIn: boolean;
  signIn: () => void;
  signOut: () => void;
}

export const useSessionStore = create<SessionState>((set) => ({
  signedIn: load(),
  signIn: () => {
    try {
      localStorage.setItem(KEY, '1');
    } catch {
      // ignora
    }
    set({ signedIn: true });
  },
  signOut: () => {
    try {
      localStorage.removeItem(KEY);
    } catch {
      // ignora
    }
    set({ signedIn: false });
  },
}));
